export default "__VITE_ASSET__BHZEJsc1__"